module.exports = __webpack_public_path__ + "img/731-08734b.png";